import { TableBadgeLabel } from '@components'

import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useQuotesListFilters } from '../../../../context/quotesListFilters'
import { useQuotesSummaryFiltered } from '../../../../hooks/useQuotesSummaryFiltered'

export const QuotesTitle = (): ReactElement => {
  const { t } = useTranslation()
  const [{ status }] = useQuotesListFilters()
  const { data, isLoading } = useQuotesSummaryFiltered()

  const totalAmount = data?.[status]?.count ?? 0

  return (
    <TableBadgeLabel amount={totalAmount} isLoading={isLoading} color="neutral">
      {t('quotes.all')}
    </TableBadgeLabel>
  )
}
